document.addEventListener('DOMContentLoaded',function(){
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealItems=document.querySelectorAll('.qf-reveal');
  if(!revealItems.length||reduced||!('IntersectionObserver' in window)){
    revealItems.forEach(function(el){el.classList.add('qf-visible');});
  }else{
    document.documentElement.classList.add('qf-motion-ready');
    var revealObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('qf-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    revealItems.forEach(function(el){revealObserver.observe(el);});
  }

  var delivery=document.querySelector('[data-qf-delivery]');
  var addButton=document.querySelector('#AddToCart');
  if(delivery&&addButton){
    var syncDelivery=function(){
      var errorText=Array.prototype.map.call(document.querySelectorAll('.product-form__error-message,.product-form__error-message-wrapper,.product-form__error'),function(el){return el.textContent||'';}).join(' ');
      var unavailable=addButton.disabled||/ausverkauft|nicht verfügbar|sold out/i.test((addButton.textContent||'')+' '+errorText);
      delivery.classList.toggle('is-unavailable',unavailable);
      var status=delivery.querySelector('[data-qf-delivery-status]');
      var title=delivery.querySelector('[data-qf-delivery-title]');
      var detail=delivery.querySelector('[data-qf-delivery-detail]');
      if(status)status.textContent=unavailable?'Aktuell nicht verfügbar':'Versandbereit';
      if(title)title.textContent=unavailable?'Diese Variante ist gerade ausverkauft':'In 1–3 Werktagen bei dir';
      if(detail)detail.textContent=unavailable?'Melde dich gerne für eine persönliche Alternative':'DHL GoGreen oder kostenlose Abholung in Ronsdorf';
    };
    syncDelivery();
    new MutationObserver(syncDelivery).observe(addButton,{attributes:true,childList:true,subtree:true});
  }
});